// formly.module.ts
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyFieldNbInput } from './formly-fields/formly-field-nb-input';
import { FormlyFieldNbRadio } from './formly-fields/formly-field-nb-radio';
import { FormlyFieldNbCheckbox } from './formly-fields/formly-field-nb-checkbox';
import { FormlyFieldNbTextarea } from './formly-fields/formly-field-nb-textarea';
import { NbCheckboxModule, NbInputModule, NbRadioModule, NbSelectModule } from '@nebular/theme';
import { FormlyFieldNbSelect } from './formly-fields/formly-field-nb-select';
import { CommonModule } from '@angular/common';
import { FormlyWrapperErrorMessageComponent } from './formly-fields/formly-wrapper-error';
import { FormlyErrorWrapperComponent } from './formly-fields/formly-wrapper-error.component';
import { FormlyFieldNbInputNumber } from './formly-fields/formly-field-nb-input-number';
import { PoundsAndKgComponent } from 'app/@components/pounds-and-kg/pounds-and-kg.component';
import { FormlyFieldNbWeight } from './formly-fields/formly-field-nb-weight';
import { ComponentsModule } from 'app/@components/components.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NbInputModule,
    NbSelectModule,
    NbCheckboxModule,
    NbRadioModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    FormlyModule.forRoot({
      wrappers: [
        { name: 'formly-wrapper-error', component: FormlyErrorWrapperComponent },
      ],
      types: [
        { name: 'nbInput', component: FormlyFieldNbInput },
        { name: 'nbRadio', component: FormlyFieldNbRadio },
        { name: 'nbCheckbox', component: FormlyFieldNbCheckbox },
        { name: 'nbTextarea', component: FormlyFieldNbTextarea },
        { name: 'nbSelect', component: FormlyFieldNbSelect },
        { name: 'nbInputNumber', component: FormlyFieldNbInputNumber },
        { name: 'nbWeight', component: FormlyFieldNbWeight },
      ],
    }),
  ],
  declarations: [
    FormlyFieldNbInput,
    FormlyFieldNbRadio,
    FormlyFieldNbCheckbox,
    FormlyFieldNbTextarea,
    FormlyFieldNbSelect,
    FormlyWrapperErrorMessageComponent,
    FormlyFieldNbInputNumber,
    FormlyErrorWrapperComponent,
    FormlyFieldNbWeight,
  ],
  exports: [
    ReactiveFormsModule,
    FormlyModule,
    CommonModule,
  ]
})
export class FormlyNebularModule { }
